import styled from 'styled-components';

export const GameTextStyled = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  opacity: 0.6;
  user-select: none;
  font-size: 2vmin;
  h2 {
    font-size: 16vmin;
    margin: 0;
    padding: 0;
    font-weight: 700;
  }
  h4 {
    font-size: 8vmin;
    margin: 0;
    padding: 0;
    font-weight: 700;
  }
  p {
    margin: 0;
    padding: 0;
    text-align: center;
  }
  @media (max-width: 768px) {
    font-size: 4vmin;
    h2 {
      font-size: 11vmin;
    }
  }

  @media (max-width: 480px) {
    font-size: 5vmin;
  }
`;
